import { FC } from 'react'
import { Dots, Flex, HStack, Spacer, VStack } from '@revolut-internal/ui-kit'

import { getMessageColorSchema } from 'components'
import { AuthorRole } from 'lib/apiClient'
import { MessageBubble } from 'components/ChatMessage/components'

export const AssistantChatMessageGenerating: FC = () => {
  return (
    <HStack align="center" space="s-12">
      <HStack align="end" width="100%">
        <VStack maxWidth="90%">
          <MessageBubble
            colorSchema={getMessageColorSchema({ messageType: AuthorRole.Agent })}
            position="left"
          >
            <Flex px="s-16" pt="s-8" pb="s-6" alignItems="center" justifyContent="center">
              <Dots color="accent" duration={900} size={20} />
            </Flex>
          </MessageBubble>
        </VStack>
        <Spacer />
      </HStack>
    </HStack>
  )
}
